import { LocalizedLink as Link } from '../components/LocalizedLink';
import { useEffect } from 'react';
import SEO from '../components/SEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';
import './LegalPage.css';
import { useTranslation } from "react-i18next";

export default function TermsOfServicePage() {
    const { t } = useTranslation();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="legal-page">
      <SEO 
        title={t('common.termsOfService')}
        description="Read the Terms of Service for using Reviio, including billing, API usage, and content policies."

      />
      <SiteHeader variant="solid" />

      <div className="legal-container">
        <div className="legal-header">
          <h1>{t('common.termsOfService')}</h1>
          <p className="legal-meta">
            <strong>{t('common.effectiveDate')}</strong>{' ' + t('common.june222026NbspNbsp')}<strong>{t('common.lastUpdated')}</strong>{' ' + t('common.june222026')}</p>
        </div>

        <div className="legal-toc">
          <h4>{t('common.tableOfContents')}</h4>
          <ol>
            <li><a href="#tos-1">{t('legal.terms.acceptanceOfTerms')}</a></li>
            <li><a href="#tos-2">{t('legal.terms.descriptionOfService')}</a></li>
            <li><a href="#tos-3">{t('legal.terms.accountRegistrationAmpEligibility')}</a></li>
            <li><a href="#tos-4">{t('legal.terms.googleAccountConnectionAmpAuthorization')}</a></li>
            <li><a href="#tos-5">{t('legal.terms.subscriptionPlansBillingAmpPayments')}</a></li>
            <li><a href="#tos-6">{t('legal.terms.aiGeneratedContent')}</a></li>
            <li><a href="#tos-7">{t('legal.terms.acceptableUsePolicy')}</a></li>
            <li><a href="#tos-8">{t('legal.terms.intellectualProperty')}</a></li>
            <li><a href="#tos-9">{t('legal.terms.dataPrivacyAmpSecurity')}</a></li>
            <li><a href="#tos-10">{t('legal.terms.thirdPartyServices')}</a></li>
            <li><a href="#tos-11">{t('legal.terms.disclaimersAmpLimitationOfLiability')}</a></li>
            <li><a href="#tos-12">{t('legal.terms.indemnification')}</a></li>
            <li><a href="#tos-13">{t('legal.terms.termination')}</a></li>
            <li><a href="#tos-14">{t('legal.terms.disputeResolutionAmpGoverningLaw')}</a></li>
            <li><a href="#tos-15">{t('legal.terms.changesToTheseTerms')}</a></li>
            <li><a href="#tos-16">{t('legal.terms.contactInformation')}</a></li>
          </ol>
        </div>

        <div className="legal-content">

          <h2 id="tos-1">{t('legal.terms.1AcceptanceOfTerms')}</h2>
          <p>{' ' + t('legal.terms.byAccessingOrUsingTheReviio')}</p>
          <p>{' ' + t('legal.terms.ifYouDoNotAgreeTo')}</p>

          <h2 id="tos-2">{t('legal.terms.2DescriptionOfService')}</h2>
          <p>{' ' + t('legal.terms.reviioIsAnAiPoweredSaas')}</p>
          <ul>
            <li>{t('legal.terms.connectingYourGoogleBusinessProfileVia')}</li>
            <li>{t('legal.terms.ingestingReviewsFromYourConnectedGoogle')}</li>
            <li>{t('legal.terms.generatingAiPoweredReplySuggestionsUsing')}</li>
            <li>{t('legal.terms.publishingRepliesToGoogleOnYour')}</li>
            <li>{t('legal.terms.managingMultipleBusinessLocationsTeamMem')}</li>
            <li>{t('legal.terms.subscriptionBillingAndReplyCreditManagem')}</li>
          </ul>

          <h2 id="tos-3">{t('legal.terms.3AccountRegistrationAmpEligibility')}</h2>
          <h3>{t('legal.terms.31Eligibility')}</h3>
          <p>{' ' + t('legal.terms.theServiceIsIntendedForBusiness')}</p>

          <h3>{t('legal.terms.32AccountCreation')}</h3>
          <p>{' ' + t('legal.terms.toUseTheServiceYouMust')}</p>
          <ul>
            <li>{t('legal.terms.provideAccurateCurrentAndCompleteInforma')}</li>
            <li>{t('legal.terms.maintainTheSecurityAndConfidentialityOf')}</li>
            <li>{t('legal.terms.promptlyUpdateAnyInformationThatBecomes')}</li>
            <li>{t('legal.terms.acceptResponsibilityForAllActivitiesThat')}</li>
            <li>{t('legal.terms.notifyUsImmediatelyAt')}<a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a>{' ' + t('legal.terms.ifYouSuspectUnauthorizedAccessTo')}</li>
          </ul>

          <h3>{t('legal.terms.33AccountRoles')}</h3>
          <p>{' ' + t('legal.terms.accountsSupportTwoRoles')}<strong>{t('legal.terms.ownerAdmin')}</strong>{' ' + t('legal.terms.fullControlIncludingBillingSettingsAnd')}<strong>{t('legal.terms.responder')}</strong>{' ' + t('legal.terms.proPlanOnlyCanViewReviews')}</p>

          <h2 id="tos-4">{t('legal.terms.4GoogleAccountConnectionAmpAuthorization')}</h2>
          <h3>{t('legal.terms.41OauthAuthorization')}</h3>
          <p>{' ' + t('legal.terms.toUseTheCoreFeaturesOf')}<code>{t('common.httpsWwwGoogleapisComAuthBusiness')}</code>{t('legal.terms.byDoingSoYouGrantReviio')}</p>
          <ul>
            <li>{t('legal.terms.listAndAccessYourGoogleBusiness')}</li>
            <li>{t('legal.terms.readReviewsForYourConnectedLocations')}</li>
            <li>{t('legal.terms.createUpdateAndDeleteOwnerReplies')}</li>
            <li>{t('legal.terms.registerForAndReceiveRealTime')}</li>
          </ul>

          <h3>{t('legal.terms.42YourResponsibilities')}</h3>
          <p>{t('legal.terms.youRepresentAndWarrantThat')}</p>
          <ul>
            <li>{t('legal.terms.youAreTheVerifiedOwnerOr')}</li>
            <li>{t('legal.terms.youHaveTheRightToAuthorize')}</li>
            <li>{t('legal.terms.youWillComplyWithAll')}<a href="https://developers.google.com/my-business/content/review-data" target="_blank" rel="noopener noreferrer">{t('legal.terms.googleBusinessProfilePolicies')}</a>{' ' + t('legal.terms.andGuidelinesRegardingReviewReplies')}</li>
          </ul>

          <h3>{t('legal.terms.43RevokingAccess')}</h3>
          <p>{' ' + t('legal.terms.youMayDisconnectYourGoogleAccount')}<a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">{t('common.googleAccountPermissions')}</a>{' ' + t('legal.terms.pageUponDisconnectionReviioWillImmediate')}</p>

          <h2 id="tos-5">{t('legal.terms.5SubscriptionPlansBillingAmpPayments')}</h2>
          <h3>{t('legal.terms.51Plans')}</h3>
          <p>{t('legal.terms.reviioOffersThreeSubscriptionPlans')}</p>
          <table>
            <thead>
              <tr><th>{t('common.feature')}</th><th>{t('common.free')}</th><th>{t('legal.terms.basic19Mo')}</th><th>{t('legal.terms.pro39Mo')}</th></tr>
            </thead>
            <tbody>
              <tr><td>{t('common.locations')}</td><td>1</td><td>1</td><td>{t('legal.terms.upTo5')}</td></tr>
              <tr><td>{t('legal.terms.aiReplyCreditsMonth')}</td><td>10</td><td>200</td><td>{t('legal.terms.1000Pooled')}</td></tr>
              <tr><td>{t('legal.terms.users')}</td><td>{t('legal.terms.1Owner')}</td><td>{t('legal.terms.1Owner')}</td><td>{t('legal.terms.ownerResponders')}</td></tr>
              <tr><td>{t('common.replyPacks')}</td><td>{t('legal.terms.no')}</td><td>{t('legal.terms.yes')}</td><td>{t('legal.terms.yes')}</td></tr>
            </tbody>
          </table>

          <h3>{t('legal.terms.52Billing')}</h3>
          <ul>
            <li>{t('legal.terms.billingIsMonthlyChargedIn')}<strong>{t('common.usd')}</strong>{t('legal.terms.monthlyReplyCreditsResetAtEach')}</li>
            <li>{t('legal.terms.anAiReplyCreditIsSplit')}<strong>{t('common.05Credit')}</strong>{' ' + t('legal.terms.isConsumedWhenAiSuggestionsAre')}<strong>{t('legal.terms.generated')}</strong>{t('legal.terms.andAnother')}<strong>{t('common.05Credit')}</strong>{' ' + t('legal.terms.whenTheReplyIs')}<strong>{t('legal.terms.published')}</strong>{' ' + t('legal.terms.toGoogle1CreditTotalPer')}</li>
            <li>{t('legal.terms.fixedTemplatedRepliesAreMeteredAt')}</li>
          </ul>

          <h3>{t('legal.terms.53PaymentProcessing')}</h3>
          <p>{' ' + t('legal.terms.paymentsAreProcessedBy')}<strong>{t('legal.terms.cybersource')}</strong>{' ' + t('legal.terms.aVisaCompanyCreditCardData')}<strong>{t('legal.terms.neverReachesOrIsStoredOn')}</strong>{t('legal.terms.byProvidingPaymentInformationYouAuthoriz')}</p>

          <h3>{t('legal.terms.54UpgradesDowngradesAmpCancellation')}</h3>
          <ul>
            <li><strong>{t('legal.terms.upgrades')}</strong>{' ' + t('legal.terms.takeEffectImmediatelyWithProratedCharges')}</li>
            <li><strong>{t('legal.terms.downgrades')}</strong>{' ' + t('legal.terms.takeEffectAtTheNextRenewal')}</li>
            <li><strong>{t('legal.terms.cancellation')}</strong>{' ' + t('legal.terms.youMayCancelYourSubscriptionAt')}</li>
          </ul>

          <h3>{t('legal.terms.55ReplyPacks')}</h3>
          <p>{' ' + t('legal.terms.basicAndProPlanUsersMay')}<strong>{t('legal.terms.expiresMonthly')}</strong>{t('legal.terms.unusedPackCreditsDoNotCarry')}</p>

          <h3>{t('legal.terms.56FailedPayments')}</h3>
          <p>{' ' + t('legal.terms.ifARecurringPaymentFailsWe')}</p>

          <h2 id="tos-6">{t('legal.terms.6AiGeneratedContent')}</h2>
          <h3>{t('legal.terms.61NatureOfAiReplies')}</h3>
          <p>{' ' + t('legal.terms.replySuggestionsAreGeneratedByA')}<strong>{t('legal.terms.suggestionsOnly')}</strong>{t('legal.terms.whileWeStriveForHighQuality')}</p>

          <h3>{t('legal.terms.62YourResponsibility')}</h3>
          <ul>
            <li>{t('legal.terms.youAreSolelyResponsibleForAll')}</li>
            <li>{t('legal.terms.ifYouUseAutoImmediateOr')}</li>
            <li>{t('legal.terms.weStronglyRecommendReviewingAiGenerated')}</li>
            <li>{t('legal.terms.youAreResponsibleForEnsuringThat')}</li>
          </ul>

          <h3>{t('legal.terms.63NoGuarantee')}</h3>
          <p>{' ' + t('legal.terms.reviioDoesNotGuaranteeThatAi')}</p>

          <h2 id="tos-7">{t('legal.terms.7AcceptableUsePolicy')}</h2>
          <p>{t('legal.terms.youAgreeNotToUseThe')}</p>
          <ul>
            <li>{t('legal.terms.violateAnyApplicableLawRegulationOr')}</li>
            <li>{t('legal.terms.postFakeMisleadingDefamatoryOrSpam')}</li>
            <li>{t('legal.terms.publishRepliesThatIncentivizeSolicitOr')}</li>
            <li>{t('legal.terms.useTheServiceForAnyBusiness')}</li>
            <li>{t('legal.terms.attemptToCircumventUsageLimitsCredit')}</li>
            <li>{t('legal.terms.reverseEngineerDecompileOrAttemptTo')}</li>
            <li>{t('legal.terms.interfereWithTheServiceRsquoS')}</li>
            <li>{t('legal.terms.useTheServiceToCollectStore')}</li>
            <li>{t('legal.terms.resellSublicenseOrRedistributeTheService')}</li>
          </ul>
          <p>{' ' + t('legal.terms.violationOfThisAcceptableUsePolicy')}</p>

          <h2 id="tos-8">{t('legal.terms.8IntellectualProperty')}</h2>
          <h3>{t('legal.terms.81ReviioRsquoSIntellectual')}</h3>
          <p>{' ' + t('legal.terms.theServiceIncludingItsSoftwareAlgorithms')}</p>

          <h3>{t('legal.terms.82YourContent')}</h3>
          <p>{' ' + t('legal.terms.youRetainOwnershipOfAllContent')}</p>

          <h3>{t('legal.terms.83AiGeneratedReplies')}</h3>
          <p>{' ' + t('legal.terms.repliesGeneratedByTheAiOn')}</p>

          <h2 id="tos-9">{t('legal.terms.9DataPrivacyAmpSecurity')}</h2>
          <p>{' ' + t('legal.terms.yourUseOfTheServiceIs')}<Link to="/privacy-policy">{t('common.privacyPolicy')}</Link>{t('legal.terms.whichDescribesHowWeCollectUse')}</p>
          <p>{' ' + t('legal.terms.weImplementIndustryStandardSecurityMeasu')}</p>

          <h2 id="tos-10">{t('legal.terms.10ThirdPartyServices')}</h2>
          <p>{' ' + t('legal.terms.theServiceIntegratesWithThirdParty')}</p>
          <ul>
            <li><strong>{t('legal.terms.googleBusinessProfileApi')}</strong>{' ' + t('legal.terms.mdashForReadingReviewsAndPublishing')}</li>
            <li><strong>{t('common.googleCloudPlatformVertexAi')}</strong>{' ' + t('legal.terms.mdashForAiReplyGeneration')}</li>
            <li><strong>{t('common.cybersourceVisa')}</strong>{' ' + t('legal.terms.mdashForPaymentProcessing')}</li>
            <li><strong>{t('legal.terms.firebaseCloudMessaging')}</strong>{' ' + t('legal.terms.mdashForPushNotifications')}</li>
          </ul>
          <p>{' ' + t('legal.terms.yourUseOfTheseThirdParty')}</p>

          <h2 id="tos-11">{t('legal.terms.11DisclaimersAmpLimitationOfLiability')}</h2>
          <h3>{t('legal.terms.111DisclaimerOfWarranties')}</h3>
          <p>{' ' + t('legal.terms.theServiceIsProvidedLdquoAs')}</p>

          <h3>{t('legal.terms.112LimitationOfLiability')}</h3>
          <p>{' ' + t('legal.terms.toTheMaximumExtentPermittedBy')}</p>
          <ul>
            <li>{t('legal.terms.yourAccessToUseOfOr')}</li>
            <li>{t('legal.terms.anyAiGeneratedContentPublishedThrough')}</li>
            <li>{t('legal.terms.unauthorizedAccessToOrAlterationOf')}</li>
            <li>{t('legal.terms.actionsOrOmissionsOfThirdParty')}</li>
            <li>{t('legal.terms.anyOtherMatterRelatingToThe')}</li>
          </ul>
          <p>{' ' + t('legal.terms.reviioRsquoSTotalAggregateLiability')}</p>

          <h2 id="tos-12">{t('legal.terms.12Indemnification')}</h2>
          <p>{' ' + t('legal.terms.youAgreeToIndemnifyDefendAnd')}</p>
          <ul>
            <li>{t('legal.terms.yourUseOfTheService')}</li>
            <li>{t('legal.terms.yourViolationOfTheseTerms')}</li>
            <li>{t('legal.terms.anyRepliesPublishedThroughYourAccount')}</li>
            <li>{t('legal.terms.yourViolationOfAnyRightsOf')}</li>
            <li>{t('legal.terms.anyContentYouUploadToThe')}</li>
          </ul>

          <h2 id="tos-13">{t('legal.terms.13Termination')}</h2>
          <h3>{t('legal.terms.131TerminationByYou')}</h3>
          <p>{' ' + t('legal.terms.youMayTerminateYourAccountAt')}<a href="mailto:support@reviio.app">{t('common.supportReviioApp')}</a>{' ' + t('legal.terms.orThroughTheAccountSettingsUpon')}</p>

          <h3>{t('legal.terms.132TerminationByReviio')}</h3>
          <p>{' ' + t('legal.terms.weMaySuspendOrTerminateYour')}</p>

          <h3>{t('legal.terms.133EffectOfTermination')}</h3>
          <p>{' ' + t('legal.terms.uponTerminationAYourRightTo')}<Link to="/privacy-policy">{t('common.privacyPolicy')}</Link>{t('legal.terms.sectionsOfTheseTermsThatBy')}</p>

          <h2 id="tos-14">{t('legal.terms.14DisputeResolutionAmpGoverningLaw')}</h2>
          <p>{' ' + t('legal.terms.theseTermsShallBeGovernedBy')}</p>

          <h2 id="tos-15">{t('legal.terms.15ChangesToTheseTerms')}</h2>
          <p>{' ' + t('legal.terms.weMayModifyTheseTermsAt')}</p>

          <h2 id="tos-16">{t('legal.terms.16ContactInformation')}</h2>
          <p>{' ' + t('legal.terms.ifYouHaveQuestionsAboutThese')}</p>
          <ul>
            <li><strong>{t('common.email2')}</strong> <a href="mailto:admin@reviio.app">{t('common.adminReviioApp')}</a></li>
            <li><strong>{t('common.generalSupport')}</strong> <a href="mailto:support@reviio.app">{t('common.supportReviioApp')}</a></li>
            <li><strong>{t('common.website')}</strong> <a href="https://reviio.com">{t('common.httpsReviioCom')}</a></li>
          </ul>

        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
